import React, { useState, useEffect } from "react";
import queryString from "query-string";
import ReportForm from "./ReportForm";
import ReportForm2ndPart from "./ReportForm2ndPart";
import ReportForm2ndPartV3Tw from "../v3/ReportForm2ndPartV3Tw";
import VipResult from "../VipResult";
import VipJumbotron from "../VipJumbotron";
import VipNewebpay from "../v3/VipNewebpay";
import VipJumbotronV3 from "../v3/VipJumbotronV3";
import VipMaintenanceBulletin from "../VipMaintenanceBulletin";
import axios from "axios";
import { isUserAuthenticated } from "../helpers/authUtils";

const VipWireReportHomeSandbox = ({ match, location }) => {
  const gameId = match.params.game_id;
  const [maintenance, setMaintenance] = useState(true);
  const [maintenanceBulletin, setMaintenanceBulletin] = useState(null);

  useEffect(() => {
    async function fetchMaintenanceBulletin() {
      const result = await axios(`/api/vipv3/maintenance`);
      
      if (result.data.msg==="OK") {
        setMaintenanceBulletin(result.data.bulletin);
      } else {
        setMaintenance(false);
      }
    }
    fetchMaintenanceBulletin();
   
  }, []);

  const [prevReport, setPrevReport] = useState({});

  useEffect(() => {
    async function fetchExistingReport(token) {
      try {
        const result = await axios(`/api/vipv2/prev_report/${token}`);
        //console.log("result", result.data.record);
        setPrevReport(result.data.record);
      } catch (error) {
        console.error(error);
      }
    }

    async function fetchMemberData(token) {
      try {
        const config = {
          headers: { 'x-auth-token': token },
        };
        const result = await axios(`/api/auth/get_member_data`, config);
        //console.log("result", result.data);
        setPrevReport(result.data);
      } catch (error) {
        //console.error(error);
      }
    }

    const search_values = queryString.parse(location.search);
    if (search_values.token) {
      fetchExistingReport(search_values.token);
    } else { 
      const isAuthTokenValid = isUserAuthenticated();
      if (isAuthTokenValid) {
        fetchMemberData(isAuthTokenValid);
      }
    }
  }, [location.search]); // Or [] if effect doesn't need props or state

  const [paymentMethod, setPaymentMethod] = useState(0);
  const [productsOption, setProductsOption] = useState([]);
  const [gift, setGift] = useState(null);
  const [donateOption, setDonateOption] = useState({});

  useEffect(() => {
    async function fetchGamesData(gameId) {
      const result = await axios(`/api/vipv3/game/${gameId}`);
      //console.log("result", result.data.tw);
      if (result.data.tw===0 && gameId !== "H73") {
        window.location.replace('/game');
      } else {
        setPaymentMethod(result.data.tw);
      }
    }
    fetchGamesData(gameId);

    async function fetchProductsData(gameId) {
      const result = await axios(`/api/vip/products/${gameId}`);
      //console.log("result", result.data.products);
      setProductsOption(result.data.products);
    }
    fetchProductsData(gameId);

    async function fetchGiftData(gameId) {
      const result = await axios(`/api/vipv2/gift/${gameId}`);
      //console.log("result", result.data.gift);
      setGift(result.data.gift);
    }
    fetchGiftData(gameId);

    async function fetchDonateData() {
      const result = await axios(`/api/vipv3/get_donate`);
      //console.log("result", result.data.donate_option);
      setDonateOption(result.data.donate_option);
    }
    fetchDonateData();
  }, [gameId]); // Or [] if effect doesn't need props or state

  //const [logData, setLogData] = useState({ report_id: "VP20200825111008wvg" });
  const [logData, setLogData] = useState({});
  const [resultData, setResultData] = useState({});
  const [resultDataV3, setResultDataV3] = useState({});

  if (resultData.report_id) {
    document.title = "龍邑遊戲 - 匯款回報完成";
    return <VipResult record={resultData} />;
  }

  if (resultDataV3.TradeInfo) {
    return <VipNewebpay record={resultDataV3} />;
  }

  const submitLog = (log) => {
    //e.preventDefault();

    //console.log("submitLog", log);
    //msg: "OK", record: log
    axios
      .post("/api/vipv2/first_step", log)
      .then((res) => {
        //console.log(res.data);

        setLogData(res.data?.record);
      })
      .catch((err) => console.log(err.message));
  };
  const submitWireReport = (report) => {
    //e.preventDefault();

    //console.log("submitLog", log);
    //msg: "OK", record: log

    axios
      .post("/api/vipv2/createReport", {
        ...report,
        report_id: logData.report_id,
      })
      .then((res) => {
        //console.log(res.data);

        setResultData(res.data?.record);
      })
      .catch((err) => console.log(err.message));
  };
  const submitWireReportV3 = (report) => {
    //e.preventDefault();

    //console.log("submitLog", log);
    //msg: "OK", record: log

    axios
      .post("/api/vipv3/createReport", {
        ...report,
        report_id: logData.report_id,
      })
      .then((res) => {
        //console.log(res.data);

        setResultDataV3(res.data?.record);
      })
      .catch((err) => console.log(err.message));
  };

  if (maintenance) {
    return <VipMaintenanceBulletin game_id={gameId} maintenanceBulletin={maintenanceBulletin} />
  }

  return (
    <div className="container">
      {(paymentMethod === 1 || gameId === "g66naxx2tw" || gameId === "h55naxx2tw") ? (
        <VipJumbotron game_id={gameId} products={productsOption} gift={gift}/>
      ) : (
        <VipJumbotronV3 game_id={gameId} products={productsOption} gift={gift} area="tw" />
      )}
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6 col-sm-12 mt-3">
          {logData.report_id && (paymentMethod === 1 || gameId === "g66naxx2tw" || gameId === "h55naxx2tw") ? (
            <ReportForm2ndPart
              gameId={gameId}
              onSubmitReport={submitWireReport}
              prevReport={prevReport}
              products={productsOption}
            />
          ) : (logData.report_id && paymentMethod === 2 && gameId !== "g66naxx2tw" && gameId !== "h55naxx2tw") || (logData.report_id && gameId === "H73") ? (
            <ReportForm2ndPartV3Tw
              gameId={gameId}
              onSubmitReport={submitWireReportV3}
              products={productsOption}
              donateOption={donateOption}
            />
          ) : (
            <ReportForm
              gameId={gameId}
              onNextStepClick={submitLog}
              prevReport={prevReport}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VipWireReportHomeSandbox;
